import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import HexagonIcon from '@mui/icons-material/Hexagon';

export const WrapperSection = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
gap: 30px;
font-size: 14px;
@media (min-width: 600px) {
   font-size: 16px;
}
`;

export const MainTitle = styled('h1')(({ theme }) => `
color: ${theme.palette.text.accent};
font-size: 24px;
text-align: center;
@media (min-width: 600px) {
   font-size: 30px;
   text-align: left;
}
`);

export const DescriptionHero = styled.p`
text-align: center;
@media (min-width: 600px) {
   text-align: left;
}
`;


export const SectionTitle = styled.h2`
font-size: 18px;
@media (min-width: 600px) {
   font-size: 24px;
}
`;

export const WrapperHero = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
gap: 20px;
text-align: left;

`;

export const WrapperDescription = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: flex-start;
align-self: flex-start;
gap: 20px;
flex: 1;
max-width: 100%;
@media (min-width: 800px) {
    max-width: 600px;
}
`;

export const WrapperImg = styled.div`
display: none;
flex:1;
border-radius: 20px;
overflow: hidden;
@media (min-width: 800px) {
   display: block;
   max-width: 600px;
}
`;

export const SectionScope = styled('section')(({ theme }) => `
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
width: 100%;
background-color: ${theme.palette.background.primary};
padding: 20px 10px;
border-radius: 20px;
@media (min-width: 600px) {
   padding: 40px;
}
`);

export const DescriptionScope = styled.p`
max-width:600px;
`;

export const AccentText = styled.span`
font-weight: 700;
text-transform: capitalize;
`;

export const ButtonKangourou = styled(Link)(({ theme }) => `
width: 70px;
height:70px;
border-radius: 6px;
border: 2px solid ${theme.palette.cadet.main};
background-color: ${theme.palette.background.light};
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
transition: box-shadow 250ms cubic-bezier(0.4,0,0.2,1) 0ms;  
&:hover{
     box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
  
  }
`);

export const LinkKangourou = styled(Link)(({ theme }) => `
display: inline;
font-weight: 500;
text-transform: capitalize;
color: ${theme.palette.text.accent};
&:hover{
         color: ${theme.palette.primary.main};
  }
`);

export const LinkBtnHome = styled(Button)(({ theme, color }) => `
 border-radius: 4px;
  padding: 6px 16px;
  min-width: 64px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.75;
  text-transform: uppercase;
  color:  ${theme.palette.text.light};
  background-color: ${theme.palette[color].main};
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);

  &:hover{
     background-color: ${theme.palette[color].dark};
  }  
`);

export const SectionCreator = styled.section`
width: 100%;
padding: 20px 10px;
@media (min-width: 600px) {
   padding: 40px;
}
`;

export const WrapperCreator = styled.div`
display: flex;
justify-content: center;
align-items: center;
gap: 30px;
margin-top: 20px;
`;

export const WrapperLogoPencil = styled.div`
display: none;
@media (min-width: 600px) {
   display: block;
   max-width: 200px;
}
`;

export const WrapperDescriptionCreator = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
`;

export const DescriptionCreator = styled.div`
max-width: 400px;
text-align: left;
`;

export const ListOption = styled('ul')(() => `
// font-weight: 700;
`);

export const ItemOption = styled('li')(() => `
display: flex;
justify-content: flex-start;
align-items: center;
gap: 4px;
`);

export const IconHexagon = styled(HexagonIcon)(({ theme }) => `
width: 16px;
height: 16px;
color: ${theme.palette.primary.main};
`);

export const SectionSubscribe = styled.section`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
width: 100%;
padding: 20px 10px;
border-radius: 20px;
border: 1px solid #EF6264;
@media (min-width: 600px) {
   padding: 40px;
}
`;

export const TitleSubscribe = styled('h2')(({ theme }) => `
font-size: 18px;
color: ${theme.palette.text.accent};
@media (min-width: 600px) {
   font-size: 24px;
}
`);

export const LogoKangourouDescription = styled.div`
display: flex;
justify-content: center;
align-items: center;
gap: 20px;
`;

export const DescriptionSubscribe = styled.p`
max-width: 400px;
`;

export const DescriptionPrivacy = styled.p`
width:100%;
text-align: center;
font-size: 14px;
@media (min-width: 600px){
font-size: 16px;
}
`;

